import { type CSSProperties } from "react";
import { z } from "zod";

import { Badge } from "~/components/ui/badge";
import {
  agaveShadowRenderCallerSchema,
  agaveShadowRenderModeSchema,
  agaveShadowRenderProductTypeSchema,
} from "~/modules/agave-shadow-renders/schemas";

export const agaveShadowRenderCallerSearchSchema = agaveShadowRenderCallerSchema.or(
  z.literal("all")
);
export const agaveShadowRenderModeSearchSchema = agaveShadowRenderModeSchema.or(z.literal("all"));
export const agaveShadowRenderProductTypeSearchSchema = agaveShadowRenderProductTypeSchema.or(
  z.literal("all")
);

const modeBadgeStyles: Record<string, CSSProperties> = {
  low: { backgroundColor: "#FFD8BE", borderColor: "#FFD8BE", color: "#000000" },
  medium: { backgroundColor: "#82ABA1", borderColor: "#82ABA1", color: "#000000" },
  high: { backgroundColor: "#B8B8FF", borderColor: "#B8B8FF", color: "#000000" },
};

function FieldBadge({
  value,
  variant = "outline",
  style,
}: {
  value?: string | null;
  variant?: "outline" | "secondary";
  style?: CSSProperties;
}) {
  if (!value) {
    return null;
  }
  return (
    <Badge variant={variant} style={style}>
      {value}
    </Badge>
  );
}

export function ModeBadge({ mode }: { mode?: string | null }) {
  return <FieldBadge value={mode} style={mode ? modeBadgeStyles[mode.toLowerCase()] : undefined} />;
}

export function ProductTypeBadge({ productType }: { productType?: string | null }) {
  return <FieldBadge value={productType} variant="secondary" />;
}

export function CallerBadge({ caller }: { caller?: string | null }) {
  return <FieldBadge value={caller} variant="secondary" />;
}

export function CreditLabel({ credits }: { credits?: number | null }) {
  if (credits == null) {
    return null;
  }
  return (
    <span className="truncate rounded bg-muted px-1.5 py-0.5 text-[11px] font-medium text-muted-foreground">
      {credits} {credits === 1 ? "credit" : "credits"}
    </span>
  );
}
